//Khai báo action type
export const UPDATE_USER_INFO = 'src/common/USER/UPDATE_USER_INFO'
export const CLEAR_USER_INFO = 'src/common/USER/CLEAR_USER_INFO'
export const LOGIN_REQUEST = 'src/common/USER/LOGIN_REQUEST'
export const LOGOUT = 'src/common/USER/LOGOUT'
export const LOGIN_SUCCESS = 'src/common/USER/LOGIN_SUCCESS'
export const LOGIN_ERROR = 'src/common/USER/LOGIN_ERROR'
export const UPDATE_ACCESS_PERMISSION =
  'src/common/USER/UPDATE_ACCESS_PERMISSION'

export const updateUserInfo = user => ({
  type: UPDATE_USER_INFO,
  user
})

export const clearUserInfo = () => ({
  type: CLEAR_USER_INFO
})

export const updateAccessPermission = roles => ({
  type: UPDATE_ACCESS_PERMISSION,
  roles
})

export const loginRequest = (user, password) => ({
  type: LOGIN_REQUEST,
  user,
  password
})

export const loginSuccess = user => ({
  type: LOGIN_SUCCESS,
  user
})

export const logoutRequest = () => ({
  type: LOGOUT
})

export const loginError = error => ({
  type: LOGIN_ERROR,
  error
})
